module.exports = __webpack_public_path__ + "static/media/account-right-chevron.46fd2e47.svg";